<template>
  <div>
    <h1 class="title">What Happened To My Order</h1>
    <div id="search_container" @keydown.enter="fetch_order()">
      <b-field label="Shopify Order ID" id="order_search" :message="errors.first('Shopify Order ID')" :type="errors.items.length > 0 ? 'is-danger': ''">
        <b-input v-validate="'required|regex:^(.*/)?[0-9]+'" v-model="order_shopify_id" id="search_input" name="Shopify Order ID"></b-input>
      </b-field>
      <b-button type="is-primary" :disabled="!formValidated" @click="fetch_order()"><span class="icon"><i class="fa fa-search"></i></span><span>Fetch status</span></b-button>
    </div>
  </div>
</template>

<script>
import auth from '../auth'
import Pagination from './Pagination'

export default {
  name: 'OrderStatus',
  computed: {
    formValidated () {
      return Object.keys(this.fields).some(key => this.fields[key].validated) && Object.keys(this.fields).some(key => this.fields[key].valid)
    }
  },
  data () {
    return {
      order_shopify_id: null,
      confirmed_order_shopify_id: null
    }
  },
  methods: {
    fetch_order () {
      if (this.formValidated) {
        const reg = /^(.*\/)?([0-9]+)/
        const matches = this.order_shopify_id.match(reg)
        if (matches) {
          this.confirmed_order_shopify_id = matches[matches.length - 1]
          this.$router.push({ path: `order_status_view/${this.confirmed_order_shopify_id}` })
        }
      }
    }
  },
  created () {
    auth.checkAuth(['read_orders'])
  },
  components: {
    Pagination
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #search_input {
    width: 50%;
  }
  #search_container {
    text-align: center;
  }
  #order_search {
    margin: 10px auto;
    width: 50%;
  }
</style>
